 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLEPAGE from '@/components/Text/titlepage'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTCREDITS from '@/components/Text/credits'
 import TEXTIVP from '@/components/Text/IVP'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/acknowledgments'
 import TEXTABBREVIATIONS from '@/components/Text/abbreviations'
 import TEXTBIBLETRANSL from '@/components/Text/bibletransl'
 import TEXTCOMMENTARYGUIDE from '@/components/Text/commentaryguide'
 import TEXTGENINTRO from '@/components/Text/genintro'
 import TEXTINTRODUCTION from '@/components/Text/introduction'
 import TEXT1SAMUEL from '@/components/Text/1samuel'
 import TEXT2SAMUEL from '@/components/Text/2samuel'
 import TEXT1KINGS from '@/components/Text/1kings'
 import TEXT2KINGS from '@/components/Text/2kings'
 import TEXT1CHRONICLES from '@/components/Text/1chronicles'
 import TEXT2CHRONICLES from '@/components/Text/2chronicles'
 import TEXTMAPANDTIMELINE from '@/components/Text/mapandtimeline'
 import TEXTFIGURESANDWORKS from '@/components/Text/figuresandworks'
 import TEXTSOURCESBIOSKETCH from '@/components/Text/sourcesbiosketch'
 import TEXTBIBLIOGRAPHY from '@/components/Text/bibliography'
 import TEXTAUTHORWRITINGSINDEX from '@/components/Text/authorwritingsindex'
 import TEXTSUBJECTINDEX from '@/components/Text/subjectindex'
 import TEXTSCRIPTUREINDEX from '@/components/Text/scriptureindex'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTPRAISE from '@/components/Text/praise'
 import TEXTADVISERS from '@/components/Text/advisers'
 import TEXTSERIESEDITORS from '@/components/Text/serieseditors'
 import TEXTVOLUMEEDITOR from '@/components/Text/volumeeditor'
 import TEXTRCONS from '@/components/Text/RConS'
 import TEXTTEXTBOOKSELECTOR from '@/components/Text/textbookselector'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/titlepage",
 			"name" : "Text/titlepage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/dedication",
 			"name" : "Text/dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/credits",
 			"name" : "Text/credits",
 			"component" : TEXTCREDITS
 		},
 		{
 			"path" : "/Text/IVP",
 			"name" : "Text/IVP",
 			"component" : TEXTIVP
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/acknowledgments",
 			"name" : "Text/acknowledgments",
 			"component" : TEXTACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Text/abbreviations",
 			"name" : "Text/abbreviations",
 			"component" : TEXTABBREVIATIONS
 		},
 		{
 			"path" : "/Text/bibletransl",
 			"name" : "Text/bibletransl",
 			"component" : TEXTBIBLETRANSL
 		},
 		{
 			"path" : "/Text/commentaryguide",
 			"name" : "Text/commentaryguide",
 			"component" : TEXTCOMMENTARYGUIDE
 		},
 		{
 			"path" : "/Text/genintro",
 			"name" : "Text/genintro",
 			"component" : TEXTGENINTRO
 		},
 		{
 			"path" : "/Text/introduction",
 			"name" : "Text/introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/1samuel",
 			"name" : "Text/1samuel",
 			"component" : TEXT1SAMUEL
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js